/* ==========================================================================
   Mundo Dos Filtros — entrega-cep.js
   Consulta de CEP (ViaCEP), aviso de região não atendida e bloqueio da compra
   fora da área de entrega.
   ========================================================================== */

(function () {
  'use strict';

  var textos = (window.tema && window.tema.textos && window.tema.textos.cep) || {};
  var CHAVE = 'mdf-entrega-cep';

  /* Versão do que fica guardado. O CEP salvo antes do roteiro não tem os dias
     de rota; ao achar um desses, a consulta é refeita sozinha. */
  var VERSAO = 2;

  /* --------------------------------------------------- Área de entrega -- */

  /* Todo o Distrito Federal é atendido — por isso o DF entra pela UF, e não
     região por região: o ViaCEP devolve "Brasília" como cidade para todas as
     RAs, então listá-las uma a uma não filtraria nada.
     No Goiás só valem as cidades do Entorno abaixo. Para mudar a cobertura,
     é esta lista que se edita. */
  /* O dia em que o caminhão passa em cada região está no roteiro, em
     entrega-prazo.js (as cidades daqui que não aparecem na planilha vão na
     quinta). */
  var CIDADES_GO = [
    'aguas lindas de goias',
    'alexania',
    'cidade ocidental',
    'cocalzinho de goias',
    'cristalina',
    'formosa',
    'luziania',
    'novo gama',
    'padre bernardo',
    'planaltina',
    'santo antonio do descoberto',
    'valparaiso de goias'
  ];

  function normalizar(texto) {
    return (texto || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  }

  function atendeEndereco(dados) {
    var uf = (dados.uf || '').toUpperCase();
    if (uf === 'DF') return true;
    if (uf === 'GO') return CIDADES_GO.indexOf(normalizar(dados.localidade)) !== -1;
    return false;
  }

  /* No DF a cidade é sempre "Brasília", o que não diz nada para quem mora lá.
     O bairro que o ViaCEP devolve é a região administrativa — é isso que a
     pessoa reconhece como o lugar onde mora. */
  function nomeLocal(dados) {
    var uf = (dados.uf || '').toUpperCase();
    var cidade = dados.localidade || '';
    if (uf === 'DF' && dados.bairro) return dados.bairro + ' - DF';
    return cidade ? cidade + ' - ' + uf : uf;
  }

  /* ------------------------------------------------------------ Textos -- */

  function preencher(modelo, valores) {
    var saida = modelo || '';
    Object.keys(valores || {}).forEach(function (chave) {
      saida = saida.replace(new RegExp('\\{\\{\\s*' + chave + '\\s*\\}\\}', 'g'), valores[chave]);
    });
    return saida;
  }

  function formatarCep(valor) {
    var digitos = (valor || '').replace(/\D/g, '').slice(0, 8);
    if (digitos.length <= 5) return digitos;
    return digitos.slice(0, 5) + '-' + digitos.slice(5);
  }

  /* ------------------------------------------------------------- Prazo -- */

  /* A conta do prazo mora em entrega-prazo.js, que carrega antes deste arquivo:
     é a mesma promessa que o selo dos cards mostra, e mantê-la em um só lugar
     evita que as duas telas divirjam. */
  function dataFormatada() {
    var prazo = window.tema && window.tema.prazo;
    if (!prazo) return '';
    var diasFixo = window.tema.prazoFixoDias;
    if (diasFixo) return 'em até ' + diasFixo + ' dias (' + prazo.formatarSimples(prazo.dataFixa(diasFixo)) + ')';
    return prazo.formatar(prazo.data(estado && estado.dias));
  }

  /* Texto de quem é atendido. A data depende do dia em que o caminhão passa
     na região (roteiro em entrega-prazo.js); região atendida mas fora da
     planilha fica sem data, porque prometer uma seria chute. */
  function textoAtende() {
    /* Produto abaixo de R$ 100 (snippets/so-retirada): não tem entrega, então
       no lugar da data vai o aviso de retirada na sede. */
    if (window.tema.soRetirada) return textos.so_retirada;
    if (!estado.dias && !window.tema.prazoFixoDias) {
      return preencher(textos.atende_sem_data, { local: estado.local });
    }
    return preencher(textos.atende, { local: estado.local, data: dataFormatada() });
  }

  /* ------------------------------------------------------------ Estado -- */

  var estado = null;

  /* Timer do disparo automático: a consulta sai sozinha quando o CEP fica
     completo, um instante depois da última tecla. */
  var timerAuto = null;

  function lerEstado() {
    try {
      return JSON.parse(window.localStorage.getItem(CHAVE));
    } catch (erro) {
      return null;
    }
  }

  function salvarEstado(novo) {
    estado = novo;
    try {
      window.localStorage.setItem(CHAVE, JSON.stringify(novo));
    } catch (erro) {
      /* Navegação anônima com storage bloqueado: o CEP só não sobrevive à
         troca de página, o resto continua funcionando. */
    }
  }

  /* Duas situações diferentes travam a compra, e o aviso precisa saber qual
     delas é. Quem ainda não informou o CEP não fez nada errado: dizer a essa
     pessoa que não entregamos na região dela seria mentira, e mentira que
     espanta cliente. Por isso o motivo anda separado do bloqueio. */
  function semCep() {
    return !estado;
  }

  function foraDaArea() {
    return !!(estado && estado.atende === false);
  }

  /* A compra fica travada até o CEP ser consultado e a região ser atendida. É
     uma troca deliberada: pede um passo a mais antes do carrinho para não
     receber pedido que não temos como entregar, o que custa estorno, suporte
     e a confiança da pessoa. */
  function bloqueado() {
    return semCep() || foraDaArea();
  }

  /* A classe no body é o que ativa, no CSS, a camada invisível sobre o botão
     "Comprar agora". Ele é renderizado pela Shopify dentro de um iframe, então
     o clique acontece em outro documento e nenhum listener nosso o alcança —
     cobrir a área é a única forma de interceptar. */
  function refletirBloqueio() {
    document.body.classList.toggle('entrega-bloqueada', bloqueado());
  }

  /* ---------------------------------------------------------- Interface -- */

  function caixasStatus() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cep-status]'));
  }

  function mostrarStatus(mensagem, tipo) {
    caixasStatus().forEach(function (caixa) {
      caixa.textContent = mensagem;
      caixa.hidden = !mensagem;
      caixa.setAttribute('data-tipo', tipo || '');
    });
  }

  function refletirEstado() {
    refletirBloqueio();
    if (!estado) return;

    /* O selo dos produtos segue a rota da região do CEP: troca junto. */
    if (window.tema && window.tema.prazo && window.tema.prazo.repintar) window.tema.prazo.repintar();

    Array.prototype.slice.call(document.querySelectorAll('[data-cep-campo]')).forEach(function (campo) {
      if (!campo.value) campo.value = estado.cep;
    });

    /* O prazo é recalculado a cada exibição, e não guardado junto do CEP: o
       estado sobrevive no localStorage, então um cálculo salvo na sexta ainda
       estaria na tela na segunda. */
    mostrarStatus(
      estado.atende ? textoAtende() : preencher(textos.nao_atende, { local: estado.local }),
      estado.atende ? 'ok' : 'erro'
    );
  }

  /* ---------------------------------------------------------- Consulta -- */

  /* Duas fontes para a mesma base dos Correios (a DNE). Ambas são gratuitas,
     públicas e liberam CORS — a API oficial dos Correios exige contrato e
     credencial, que não pode viver num arquivo de tema, que é público.
     Consultar a segunda só quando a primeira falha deixa a consulta de pé
     quando um dos serviços sai do ar. */
  var FONTES = [
    {
      url: function (cep) { return 'https://viacep.com.br/ws/' + cep + '/json/'; },
      ler: function (dados) {
        if (dados.erro) return null;
        return { uf: dados.uf, localidade: dados.localidade, bairro: dados.bairro };
      }
    },
    {
      url: function (cep) { return 'https://brasilapi.com.br/api/cep/v2/' + cep; },
      ler: function (dados) {
        if (!dados.state) return null;
        return { uf: dados.state, localidade: dados.city, bairro: dados.neighborhood };
      }
    }
  ];

  /* Sem o corte de tempo, um serviço que aceita a conexão e não responde deixa
     o botão desabilitado para sempre. */
  function buscarComPrazo(url) {
    var controle = window.AbortController ? new AbortController() : null;
    var tempo = window.setTimeout(function () {
      if (controle) controle.abort();
    }, 8000);

    return fetch(url, controle ? { signal: controle.signal } : undefined)
      .then(function (resposta) {
        /* CEP que não existe volta como 404 (BrasilAPI) ou 400 (ViaCEP, quando
           recusa o formato). Isso é "não encontrei", não "o serviço caiu" — sem
           essa distinção, digitar um CEP inválido acusava falha de conexão. */
        if (resposta.status === 404 || resposta.status === 400) throw new Error('nao-encontrado');
        if (!resposta.ok) throw new Error('http');
        return resposta.json();
      })
      .finally(function () {
        window.clearTimeout(tempo);
      });
  }

  function consultar(cep, indice) {
    var i = indice || 0;
    var fonte = FONTES[i];
    var ultima = i === FONTES.length - 1;

    return buscarComPrazo(fonte.url(cep))
      .then(function (dados) {
        var endereco = fonte.ler(dados);
        if (!endereco) throw new Error('nao-encontrado');
        return endereco;
      })
      .catch(function (erro) {
        /* Qualquer falha — inclusive "não achei" — passa a bola para a próxima
           fonte: um CEP ausente numa base pode existir na outra. Só a última
           decide qual mensagem a pessoa vê. */
        if (!ultima) return consultar(cep, i + 1);
        throw erro;
      });
  }

  function verificar(form) {
    var campo = form.querySelector('[data-cep-campo]');
    var botao = form.querySelector('[data-cep-enviar]');
    if (!campo) return Promise.resolve();

    var cep = (campo.value || '').replace(/\D/g, '');
    if (cep.length !== 8) {
      mostrarStatus(textos.invalido, 'erro');
      campo.focus();
      return Promise.resolve();
    }

    if (botao) botao.disabled = true;
    mostrarStatus(textos.verificando, '');

    return consultar(cep)
      .then(function (dados) {
        var atende = atendeEndereco(dados);
        var prazo = window.tema && window.tema.prazo;
        var novo = {
          versao: VERSAO,
          cep: formatarCep(cep),
          local: nomeLocal(dados),
          atende: atende,
          dias: atende && prazo ? prazo.diasDoEndereco(dados) : null
        };
        salvarEstado(novo);
        refletirEstado();

        /* Corrigiu o CEP dentro do aviso e agora entregamos: o aviso sai da
           frente sozinho, sem obrigar a fechar na mão para continuar, e a ação
           que ficou travada segue de onde parou. Sem isso a pessoa digita o
           CEP, vê o aviso sumir e o produto não entra no carrinho: ela clicou
           em comprar e nada aconteceu. */
        if (novo.atende) {
          var retomar = pendente;
          fecharModal();
          reenviar(retomar);
        }
      })
      .catch(function (erro) {
        mostrarStatus(erro && erro.message === 'nao-encontrado' ? textos.nao_encontrado : textos.erro, 'erro');
      })
      .finally(function () {
        if (botao) botao.disabled = false;
      });
  }

  /* ------------------------------------------------------------- Aviso -- */

  var modal = null;
  var focoAnterior = null;

  /* O formulário que a pessoa tentou enviar antes de o aviso aparecer. Só vale
     para adicionar ao carrinho: o "Comprar agora" mora num iframe da Shopify e
     não há como reproduzir aquele clique de fora. */
  var pendente = null;

  /* O botão de adicionar entra como remetente explícito. O product-form.js
     olha o evento.submitter para distinguir "adicionar ao carrinho" de
     "finalizar compra", e um reenvio sem remetente o deixaria adivinhando. */
  function reenviar(form) {
    if (!form || !form.isConnected) return;

    var botao = form.querySelector('[data-adicionar]');

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(botao || undefined);
      return;
    }

    /* Safari antigo não tem requestSubmit. O evento na mão basta porque o
       product-form.js escuta submit no document e cancela o envio nativo. */
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function abrirModal() {
    modal = modal || document.querySelector('[data-entrega-modal]');
    if (!modal) return;

    var titulo = modal.querySelector('[data-entrega-modal-titulo]');
    var texto = modal.querySelector('[data-entrega-modal-texto]');
    var fora = foraDaArea();

    if (titulo) {
      titulo.textContent = fora ? textos.modal_titulo : textos.modal_titulo_sem_cep;
    }

    if (texto) {
      texto.textContent = fora
        ? preencher(textos.modal_texto, { cep: estado.cep, local: estado.local })
        : textos.modal_texto_sem_cep;
    }

    focoAnterior = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('sem-scroll');

    var campo = modal.querySelector('[data-cep-campo]');
    if (campo) {
      campo.value = '';
      campo.focus();
    }
  }

  function fecharModal() {
    /* Fechar na mão desiste da ação travada. Sem isso, consultar um CEP no
       formulário da página do produto minutos depois jogaria no carrinho um
       produto que a pessoa já tinha deixado para trás. */
    pendente = null;
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('sem-scroll');
    if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
  }

  /* ----------------------------------------------------------- Eventos -- */

  function iniciar() {
    estado = lerEstado();
    modal = document.querySelector('[data-entrega-modal]');
    refletirEstado();

    /* CEP salvo antes do roteiro: refaz a consulta em silêncio para descobrir
       os dias de rota. Até lá vale o que estava salvo, e se a consulta falhar
       também, sem travar a compra de quem já tinha sido liberado. */
    if (estado && estado.versao !== VERSAO) {
      var antigo = estado.cep.replace(/\D/g, '');
      consultar(antigo)
        .then(function (dados) {
          var prazo = window.tema && window.tema.prazo;
          var atende = atendeEndereco(dados);
          salvarEstado({
            versao: VERSAO,
            cep: formatarCep(antigo),
            local: nomeLocal(dados),
            atende: atende,
            dias: atende && prazo ? prazo.diasDoEndereco(dados) : null
          });
          refletirEstado();
        })
        .catch(function () {});
    }

    document.addEventListener('input', function (evento) {
      var campo = evento.target.closest('[data-cep-campo]');
      if (!campo) return;
      campo.value = formatarCep(campo.value);

      /* Assim que o CEP fica completo (8 dígitos), a consulta dispara sozinha —
         sem precisar apertar "Verificar". Um respiro depois da última tecla
         evita chamar as APIs a cada dígito de quem cola ou digita rápido, e
         repetir o mesmo CEP já consultado também não vale a pena. */
      window.clearTimeout(timerAuto);
      var form = campo.closest('[data-cep-form]');
      if (!form) return;

      var digitos = (campo.value || '').replace(/\D/g, '');
      if (digitos.length !== 8) return;
      if (estado && estado.cep === formatarCep(digitos)) return;

      timerAuto = window.setTimeout(function () {
        verificar(form);
      }, 500);
    });

    document.addEventListener('submit', function (evento) {
      var form = evento.target.closest('[data-cep-form]');
      if (!form) return;
      evento.preventDefault();
      window.clearTimeout(timerAuto);
      verificar(form);
    });

    document.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-entrega-modal-fechar]')) fecharModal();
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') fecharModal();
    });

    /* Os dois bloqueios rodam na fase de captura para chegar antes do
       product-form.js, que escuta no document na fase de propagação: parar o
       evento aqui impede que o produto chegue a ser adicionado. */
    document.addEventListener(
      'submit',
      function (evento) {
        if (!bloqueado()) return;
        var form = evento.target.closest('[data-produto-form]');
        if (!form) return;
        evento.preventDefault();
        evento.stopPropagation();
        pendente = form;
        abrirModal();
      },
      true
    );

    /* "Comprar agora" vai direto ao checkout sem passar pelo submit do
       formulário. O clique cai na camada que o CSS põe sobre ele quando a
       entrega está bloqueada, e é o wrapper que recebe o evento. */
    document.addEventListener(
      'click',
      function (evento) {
        if (!bloqueado()) return;
        var botao = evento.target.closest('.produto__comprar-agora, [data-shopify="payment-button"]');
        if (!botao) return;
        evento.preventDefault();
        evento.stopPropagation();
        pendente = null;
        abrirModal();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
